export default "__VITE_ASSET__o3R7DuqD__"